import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import platform from '../platform';
import Jsonp from '../utils/jsonp';
import env from '../env';
import UA from '../ua';
import Store from '../store';
import Cookie from '../utils/cookie';
import redirUrl from '../utils/redirect';
import Event from '../event';
var isNative = UA.isNative;

var KNBP = require('@dp/knb').getPromiseInstance();

var tokenCookie = platform.tokenCookie;
var isProd = env.isProduct || env.isPpe;
var defUser = {
  isLogin: false,
  token: undefined,
  openId: undefined,
  userId: undefined,
  uuid: undefined,
  dpid: undefined,
  userType: undefined,
  fingerprint: 0
};

var User = /*#__PURE__*/function () {
  function User() {
    _classCallCheck(this, User);

    this.data = defUser;
    this.loginUrl = 'https://passport.maoyan.com/login?pagesource=show&redirectURL=';
    this.loginBetaUrl = 'https://passport.test.maoyan.com/login?pagesource=show&redirectURL=';
    this.logoutUrl = '//passport.maoyan.com/logout?backURL=';
    this.logoutBetaUrl = 'https://passport.test.maoyan.com/logout?backURL=';
  }

  _createClass(User, [{
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var opts,
            user,
            loginUrl,
            loginBetaUrl,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
                  success: function success() {},
                  redirUrl: '',
                  force: false
                }; // 已登录， 直接返回用户信息

                opts = opts || {};
                _context.next = 4;
                return this.getUserInfo();

              case 4:
                user = _context.sent;

                if (!(user.isLogin && !opts.force)) {
                  _context.next = 11;
                  break;
                }

                if (!opts.redirUrl) {
                  _context.next = 10;
                  break;
                }

                location.href = redirUrl;
                _context.next = 11;
                break;

              case 10:
                return _context.abrupt("return", user);

              case 11:
                if (!platform.login) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", platform.login());

              case 13:
                user = defUser;
                opts.redirUrl = opts.redirUrl || location.href; // 自定义 loginUrl 跳转登录

                loginUrl = platform.loginUrl, loginBetaUrl = platform.loginBetaUrl;

                if (!(isProd && loginUrl || !isProd && loginBetaUrl)) {
                  _context.next = 23;
                  break;
                }

                this.loginUrl = loginUrl;
                this.loginBetaUrl = loginBetaUrl;

                this._urlLogin(opts.redirUrl);

                return _context.abrupt("return", Promise.reject(new Error('url 方式跳转，不执行 resolve ')));

              case 23:
                if (!isNative) {
                  _context.next = 34;
                  break;
                }

                if (!(user.isLogin && opts.force)) {
                  _context.next = 27;
                  break;
                }

                _context.next = 27;
                return KNBP.logout();

              case 27:
                _context.next = 29;
                return KNBP.login().then(function (res) {
                  return res;
                }).catch(function (err) {
                  console.warn(err);
                });

              case 29:
                user = _context.sent;
                this.data = user || {};
                return _context.abrupt("return", user);

              case 34:
                // 默认猫眼i版登录
                this._urlLogin(opts.redirUrl);

                return _context.abrupt("return", Promise.reject(new Error('url 方式跳转，不执行 resolve ')));

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "_urlLogin",
    value: function _urlLogin(redirUrl) {
      redirUrl = encodeURIComponent(redirUrl);
      location.href = (isProd ? this.loginUrl : this.loginBetaUrl) + redirUrl;
    }
  }, {
    key: "logout",
    value: function logout(backUrl) {
      var _this = this;

      this.setToken(''); // 登出

      if (isNative) {
        return KNBP.logout(function (res) {
          _this.data = defUser;
          return res;
        });
      } else {
        if (platform.logoutBeta) {
          location.href = platform.logoutBeta;
          return;
        }

        var logoutAndRedirectUrl = isProd ? this.logoutUrl : this.logoutBetaUrl;
        location.href = logoutAndRedirectUrl + (backUrl ? encodeURIComponent(backUrl) : '');
        return Promise.resolve();
      }
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      // 非 设置token
      // if ( token ) {
      this.data.token = token;
      this.data.isLogin = !!token;
      Event.trigger('tokenChange', token); // }
    }
  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var user;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 获取用户信息
                user = {};

                if (!platform.getUserInfo) {
                  _context2.next = 5;
                  break;
                }

                user = platform.getUserInfo.call(this);
                _context2.next = 12;
                break;

              case 5:
                if (!isNative) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 8;
                return KNBP.getUserInfo().then(function (res) {
                  return res;
                }).catch(function (err) {
                  console.warn(err);
                });

              case 8:
                user = _context2.sent;
                _context2.next = 12;
                break;

              case 11:
                if (tokenCookie) {
                  user = {
                    token: Cookie.get(tokenCookie)
                  };
                }

              case 12:
                Object.assign(this.data, user, {
                  isLogin: !!(user.userId && +user.userId !== -1 || user.token)
                });
                return _context2.abrupt("return", this.data);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }()
  }, {
    key: "getUserInfoSync",
    value: function getUserInfoSync() {
      return this.data;
    }
  }, {
    key: "getUuid",
    value: function () {
      var _getUuid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var uuid, locUuid;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 获取uuid
                uuid = this.data.uuid || '';

                if (!this.data.uuid) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", this.data.uuid);

              case 3:
                _context3.next = 5;
                return Store.get('uuid');

              case 5:
                locUuid = _context3.sent;

                if (!locUuid) {
                  _context3.next = 9;
                  break;
                } // 如果本地存在， 直接返回


                this.data.uuid = locUuid;
                return _context3.abrupt("return", locUuid);

              case 9:
                uuid = this.setUuid();
                return _context3.abrupt("return", uuid);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getUuid() {
        return _getUuid.apply(this, arguments);
      }

      return getUuid;
    }()
  }, {
    key: "setUuid",
    value: function setUuid(uuid) {
      if (!uuid) {
        // 随机生成64位uuid
        uuid = new Array(8).fill(0).reduce(function (x) {
          return x + Math.random().toString(36).slice(2, 10);
        }, '');
      } // 默认保存一年


      Store.set('uuid', uuid, {
        expires: '365D'
      });
      this.data.uuid = uuid;
      return uuid;
    }
  }, {
    key: "getFingerprint",
    value: function getFingerprint() {
      var _this2 = this;

      return KNBP.getFingerprint().then(function (res) {
        _this2.data.fingerprint = res.fingerprint;
        return res.fingerprint;
      }, function (fail) {
        return 0;
      }).catch(function (err) {
        console.warn(err);
      });
    }
  }, {
    key: "openId",
    get: function get() {
      // 获取openid
      return this.data.openId;
    }
  }, {
    key: "token",
    get: function get() {
      // 获取token
      return this.data.token;
    }
  }, {
    key: "uuid",
    get: function get() {
      return this.data.uuid;
    }
  }, {
    key: "isLogin",
    get: function get() {
      return this.data && !!this.data.token;
    }
  }, {
    key: "userId",
    get: function get() {
      return this.data.userId;
    }
  }, {
    key: "fingerprint",
    get: function get() {
      return this.data.fingerprint;
    }
  }]);

  return User;
}();

export default new User();